export const App = {
    // api: 'http://localhost/eusystem-backend/public/api/'
    api: 'https://service.eus.tech/api/',
    // api: 'http://eusystem-backend-upgrade.test:8080/api/'
      // api: 'http://192.168.1.9/eusystem-backend-upgrade/public/api/',
} 